import { memo, useEffect, useState } from 'react';
import { StaticImageData } from 'next/image';
import classnames from 'classnames';

import styles from './ClosingHero.module.scss';

import BaseImage from '@/components/BaseImage/BaseImage';
import Cta from '@/components/Cta/Cta';

import useLayout from '@/hooks/use-layout';

export type Props = {
  className?: string;
  title: string;
  eyebrow: string;
  description: string;
  image: {
    data: StaticImageData;
    tabletData: StaticImageData;
    desktopData: StaticImageData;
    alt: string;
  };
  cta: {
    href: string;
    text: string;
  };
};

function ClosingHero({ className, title, eyebrow, description, image, cta }: Props) {
  const [finalSrc, setFinalSrc] = useState<StaticImageData>(image.desktopData);
  const { layout } = useLayout();

  useEffect(() => {
    layout.mobile
      ? setFinalSrc(image.data)
      : layout.tablet
      ? setFinalSrc(image.tabletData)
      : setFinalSrc(image.desktopData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layout]);
  return (
    <section className={classnames(styles.ClosingHero, className)}>
      <div className={styles.content}>
        <p className={styles.eyebrow}>{eyebrow}</p>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        <Cta className={styles.cta} title={cta.text} href={cta.href} />
      </div>

      <BaseImage className={styles.image} data={finalSrc} alt={image.alt} loading="eager" />
    </section>
  );
}

export default memo(ClosingHero);
